var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15384_1079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 17,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.25,
    y: 9,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15384_1079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2944 18.6722C20.1684 18.5833 20.0943 18.4639 20.0721 18.3139C20.0498 18.1639 20.0832 18.0259 20.1721 17.9C20.2787 17.7346 20.3663 17.5579 20.4347 17.3699C20.5033 17.1819 20.5528 16.9901 20.5832 16.7945C20.6129 16.6352 20.6811 16.5019 20.7879 16.3945C20.8948 16.2871 21.0272 16.2334 21.1852 16.2334C21.3431 16.2334 21.474 16.2892 21.5777 16.4009C21.6814 16.5125 21.7221 16.6474 21.6999 16.8055C21.6591 17.1145 21.5878 17.4168 21.4861 17.7124C21.3842 18.0078 21.2443 18.2852 21.0666 18.5445C20.9777 18.6704 20.8585 18.7454 20.7089 18.7695C20.5593 18.7935 20.4212 18.7611 20.2944 18.6722ZM17.0714 10.3334C17.5682 10.3334 17.9906 10.5073 18.3387 10.8552C18.687 11.203 18.8611 11.6253 18.8611 12.1222V15.6889C18.8611 15.8741 18.8034 16.013 18.6881 16.1055C18.5727 16.1982 18.4458 16.2445 18.3074 16.2445C18.1691 16.2445 18.0416 16.1957 17.9249 16.0979C17.8082 16.0002 17.7499 15.8583 17.7499 15.6722V12.1222C17.7499 11.9302 17.685 11.7693 17.5551 11.6394C17.4252 11.5095 17.2642 11.4445 17.0721 11.4445C16.8801 11.4445 16.7191 11.5095 16.5892 11.6394C16.4593 11.7693 16.3944 11.9302 16.3944 12.1222V13.2112C16.3944 13.3963 16.3367 13.5352 16.2214 13.6279C16.1061 13.7204 15.9792 13.7667 15.8407 13.7667C15.7024 13.7667 15.5749 13.7188 15.4582 13.623C15.3416 13.5273 15.2832 13.3881 15.2832 13.2055V12.1222C15.2832 11.6253 15.4571 11.203 15.8047 10.8552C16.1525 10.5073 16.5747 10.3334 17.0714 10.3334ZM16.5166 22.4445V20.8055C15.4647 20.6797 14.5563 20.2491 13.7916 19.5139C13.0268 18.7788 12.5777 17.876 12.4444 16.8055C12.4222 16.6474 12.4632 16.5125 12.5676 16.4009C12.672 16.2892 12.8035 16.2334 12.9621 16.2334C13.1206 16.2334 13.2534 16.2877 13.3604 16.3962C13.4674 16.5049 13.5343 16.6395 13.5611 16.8C13.7017 17.663 14.1073 18.3677 14.7777 18.9139C15.4481 19.4602 16.2134 19.7334 17.0737 19.7334C17.4801 19.7334 17.8697 19.6683 18.2427 19.538C18.6158 19.4077 18.9553 19.2247 19.2611 18.9889L20.0554 19.7834C19.7184 20.0612 19.3452 20.2873 18.9359 20.4619C18.5265 20.6364 18.0904 20.751 17.6277 20.8055V22.4445C17.6277 22.6019 17.5743 22.7338 17.4674 22.8404C17.3605 22.9468 17.2281 23 17.0702 23C16.9122 23 16.7805 22.9468 16.6749 22.8404C16.5693 22.7338 16.5166 22.6019 16.5166 22.4445ZM22.5166 23.7112L10.3277 11.5222C10.2277 11.4222 10.1777 11.3 10.1777 11.1555C10.1777 11.0111 10.2277 10.8889 10.3277 10.7889C10.4277 10.6889 10.55 10.6389 10.6944 10.6389C10.8388 10.6389 10.9611 10.6889 11.0611 10.7889L23.2499 22.9779C23.3499 23.0779 23.3999 23.2001 23.3999 23.3445C23.3999 23.489 23.3499 23.6112 23.2499 23.7112C23.1499 23.8112 23.0277 23.8612 22.8832 23.8612C22.7388 23.8612 22.6166 23.8112 22.5166 23.7112Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/mute_icon.beea7045891a6a1c450cdd9b5db4df03.svg";
export { ForwardRef as ReactComponent };